import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  height: 99vh;
`;
const FlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const User = styled(FlexDiv)`
  ${({ theme }) => `
    background-color: ${theme.palette.primary.alt};
    padding: ${theme.spacing(2)};
  `};
  flex-grow: 1;
`;
